// extracted by mini-css-extract-plugin
export var assigneeBadge = "_iz-0";
export var assigneeDetails = "_iz-1";
export var assigneeInfo = "_iz-2";
export var dropdownContainer = "_iz-4";
export var dropdownImage = "_iz-5";
export var editAssigneeInfo = "_iz-3";
export var editAssigneeModalContainer = "_iz-6";
export var hidden = "_iz-8";
export var input = "_iz-7";